'use strict';

"use strict";
const pluginVersion = "12.4.1";

exports.pluginVersion = pluginVersion;
